import { render, staticRenderFns } from "./Basicinfo.vue?vue&type=template&id=149e34ea"
import script from "./Basicinfo.vue?vue&type=script&lang=js"
export * from "./Basicinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports